// extracted by mini-css-extract-plugin
module.exports = {"box":"bf049","title":"d686f","text":"ffe0b"};